import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {Credit, CreditList} from "../http/protocol";
import {HttpService} from "../http/HttpService";


export class CreditService extends AbstractAdminEntityService<Credit, CreditList> implements CreditService{

    constructor(http : HttpService) {
        super("/credit", http);
    }

    cancelCredit(id: number): Promise<{}> {
        return this.http.get(this.entityPath + "/cancel/" + id);
    }

    completedCredit(id: number): Promise<{}> {
        return this.http.get(this.entityPath + "/complet/" + id);
    }

    addCredit(credit: Credit): Promise<Credit> {
        return this.http.post(this.entityPath + `/add`, credit);
    }

    collectCredit(credit: Credit): Promise<Credit> {
        return this.http.post(this.entityPath + `/collect`, credit);
    }
}